var _rect, _line, _line2, _line3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 14,
    height: 14,
    rx: 1,
    stroke: "white",
    strokeWidth: 1.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 5.5,
    x2: 15.5,
    y2: 5.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.6,
    y1: 1.6,
    x2: 4.6,
    y2: 2.4,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 13.6,
    y1: 1.6,
    x2: 13.6,
    y2: 2.4,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50943 10.0759C7.33437 9.79452 6.96437 9.70836 6.68302 9.88342C6.40167 10.0585 6.3155 10.4285 6.49057 10.7098L7.50943 10.0759ZM8 12L7.49057 12.317C7.57942 12.4598 7.72412 12.5587 7.88943 12.5897C8.05473 12.6207 8.22545 12.5809 8.36 12.48L8 12ZM12.36 9.48C12.6251 9.28118 12.6788 8.9051 12.48 8.64C12.2812 8.3749 11.9051 8.32118 11.64 8.52L12.36 9.48ZM6.49057 10.7098L7.49057 12.317L8.50943 11.683L7.50943 10.0759L6.49057 10.7098ZM8.36 12.48L12.36 9.48L11.64 8.52L7.64 11.52L8.36 12.48Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/event_icon.d2be24a2f2e468f89acf9f55d22d3919.svg";
export { ForwardRef as ReactComponent };